import { execute } from './execute';
import { clearTokens, getRefreshToken, setTokens } from './tokenStorage';

/**
 * Authentication calls.
 *
 * Each one owns the token side-effect that belongs with it, so no caller can
 * sign in and forget to store the tokens, or sign out and leave them behind.
 */

/** Exchanges credentials for a token pair and stores it. Returns the user. */
export async function login({ userId, password }) {
  const result = await execute('auth.login', { userId, password });

  setTokens({ accessToken: result.accessToken, refreshToken: result.refreshToken });
  return result.user;
}

/**
 * Revokes the refresh token and clears local state.
 *
 * The local clear happens even if the server call fails. A user who pressed
 * "sign out" must end up signed out on this device regardless of whether the
 * network was there — the worst case is a refresh token that stays valid
 * server-side until it expires, which is far better than a session that looks
 * closed and is not.
 */
export async function logout() {
  const refreshToken = getRefreshToken();

  try {
    if (refreshToken) await execute('auth.logout', { refreshToken });
  } finally {
    clearTokens();
  }
}

/** The signed-in user, including the tiles their role grants. */
export function fetchCurrentUser() {
  return execute('auth.me');
}

/** Changes the signed-in account's own password. */
export function changePassword({ currentPassword, newPassword }) {
  return execute('auth.changePassword', { currentPassword, newPassword });
}
